import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'

export const PopoverIcon = ({
  placement = 'left',
  children,
  html,
  popoverId,
  container = null
}) => {
  const content = html ? <div dangerouslySetInnerHTML={{__html: html}} /> : children
  return <OverlayTrigger
    trigger={['hover', 'click', 'focus']}
    placement={placement}
    container={container}
    overlay={<Popover id={popoverId}><Popover.Content>{content}</Popover.Content></Popover>}
  >
    <span className='generic-popover-icon'></span>
  </OverlayTrigger>
}
